import api from "../../utils/api";

const getUserId = () => localStorage.getItem("userId");

/* ================= GET PROFILE ================= */
export const getProfile = async () => {
  const res = await api.get(
    `/client/user/profile?userId=${getUserId()}`
  );
  return res.data;
};

/* ================= UPDATE PROFILE ================= */
export const updateProfile = async (formData) => {
  const res = await api.patch(
    `/client/user/updateProfile?userId=${getUserId()}`,
    formData
  );
  return res.data;
};

/* ================= CHANGE PASSWORD ================= */
export const changePassword = async (formData) => {
  const res = await api.patch(
    `/client/user/updatePassword`,
    formData
  );
  return res.data;
};

/* ================= WALLET HISTORY ================= */
export const fetchWalletHistory = async (
  startDate = "All",
  endDate = "All"
) => {
  const res = await api.get(
    `/client/user/fetchWalletHistoryByUser?userId=${getUserId()}&startDate=${startDate}&endDate=${endDate}`
  );
  return res.data;
};

/* ================= REFERRAL HISTORY ================= */
export const fetchReferralHistory = async (
  startDate = "All",
  endDate = "All"
) => {
  const res = await api.get(
    `/client/user/loadReferralHistoryByUser?userId=${getUserId()}&startDate=${startDate}&endDate=${endDate}`
  );
  return res.data;
};
